{
    "AgentOmnichannel_AllowAnsweringConcurrent": "Antwoord op gelijktijdige kanalen toestaan:",
    "AgentOmnichannel_Chat_IntegrationType": "Type chatintegratie:",
    "AgentOmnichannel_Chat_IDOnChatSystem": "ID op chatsysteem:",
    "AgentOmnichannel_Chat_LiveChatAgentID": "Livechat Agent ID:",
    "AgentOmnichannel_Email_IntegrationType": "Type e-mailintegratie:",
    "AgentOmnichannel_Email_EmailAddress": "E-mailadres:",
    "AgentOmnichannel_Email_IDOnEmailSystem": "ID op e-mailsysteem:",
    "AgentOmnichannel_Chat_IntegrationTypes_None": "[Geen]",
    "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",
    "AgentOmnichannel_Email_IntegrationTypes_None": "[Geen]",
    "AgentOmnichannel_Email_IntegrationTypes_Pop3": "E-mail (POP3 en SMTP)",
    "AgentOmnichannel_Email_EmailAddress_Invalid": "E-mailadres is ongeldig",
    "NAME": "AgentOmnichannel"
}